module.exports = __webpack_public_path__ + "img/icon1.59d2ff2d.svg";